export const DATA = 'DATA'
export const COMMENTS = 'COMMENTS'
export const HIGHLIGHT_COMMENT = 'HIGHLIGHT_COMMENT'
export const MERGE_NEW_COMMENT = 'MERGE_NEW_COMMENT'
export const TRIGGER_REPLY_COMMENT = 'TRIGGER_REPLY_COMMENT'



// WEBPACK FOOTER //
// ./src/vuex/builder/types.js